import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-5"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "search-bar" };
const _hoisted_4 = {
    key: 0,
    class: "empty-text"
};
const _hoisted_5 = { class: "month-label" };
const _hoisted_6 = { class: "month-rows" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "doc-info" };
const _hoisted_9 = { class: "doc-company" };
const _hoisted_10 = { class: "doc-filename" };
const _hoisted_11 = { class: "doc-added" };
const _hoisted_12 = {
    key: 0,
    class: "doc-label"
};
const _hoisted_13 = ["src"];
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useDocuments } from '@/composables/useDocuments';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AllDocumentsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDocuments } = useDocuments();
        const searchQuery = ref('');
        const sorted = computed(() => {
            if (!state.documents)
                return [];
            return [...state.documents].sort((a, b) => new Date(b.createDateTime).getTime() - new Date(a.createDateTime).getTime());
        });
        const filteredGroups = computed(() => {
            const q = (searchQuery.value || '').toLowerCase().trim();
            const docs = q
                ? sorted.value.filter((doc) => (doc.company || '').toLowerCase().includes(q) ||
                    (doc.documentName || '').toLowerCase().includes(q) ||
                    (doc.documentSubject || '').toLowerCase().includes(q))
                : sorted.value;
            const groups = [];
            const map = {};
            docs.forEach((doc) => {
                const d = new Date(doc.createDateTime);
                const label = d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
                if (!map[label]) {
                    map[label] = { monthLabel: label, docs: [] };
                    groups.push(map[label]);
                }
                map[label].docs.push(doc);
            });
            return groups;
        });
        function formatDate(dateStr) {
            if (!dateStr)
                return '';
            const d = new Date(dateStr);
            return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
        }
        function onLoad() {
            getCustomer(() => {
                getDocuments();
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "All documents" }),
                (!(_unref(state).customer && _unref(state).documents))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_skeleton_loader, {
                            width: "100%",
                            type: "text",
                            class: "mb-4"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            width: "100%",
                            type: "card",
                            class: "mb-3"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            width: "100%",
                            type: "card",
                            class: "mb-3"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            width: "100%",
                            type: "card",
                            class: "mb-3"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            width: "100%",
                            type: "card"
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).documents)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: searchQuery.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                        "prepend-inner-icon": "mdi-magnify",
                                        density: "compact",
                                        label: "Search documents",
                                        variant: "solo",
                                        flat: true,
                                        "hide-details": "",
                                        clearable: "",
                                        "single-line": "",
                                        "bg-color": "#eeeeee"
                                    }, null, 8, ["modelValue"])
                                ]),
                                (filteredGroups.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No documents found"))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups.value, (group) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: group.monthLabel
                                    }, [
                                        _createElementVNode("p", _hoisted_5, _toDisplayString(group.monthLabel), 1),
                                        _createElementVNode("div", _hoisted_6, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.docs, (doc) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: doc.id,
                                                    class: "doc-row",
                                                    onClick: ($event) => (_unref(router).push('/Documents/' + doc.id))
                                                }, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        _createElementVNode("p", _hoisted_9, _toDisplayString(doc.company || doc.documentSubject), 1),
                                                        _createElementVNode("p", _hoisted_10, _toDisplayString(doc.documentName), 1),
                                                        _createElementVNode("p", _hoisted_11, "Added " + _toDisplayString(formatDate(doc.createDateTime)), 1),
                                                        (doc.documentSubject)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(doc.documentSubject), 1))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("img", {
                                                        src: require('@/assets/arrow-right.png'),
                                                        class: "doc-arrow"
                                                    }, null, 8, _hoisted_13)
                                                ], 8, _hoisted_7));
                                            }), 128))
                                        ])
                                    ], 64));
                                }), 128)),
                                _cache[1] || (_cache[1] = _createElementVNode("div", { style: { "clear": "both", "padding-bottom": "110px" } }, null, -1))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
